module.exports = __webpack_public_path__ + "media/images/application/template/footer-logo-4-0461605ff225ab236f8fb4bdc584596c.png";